import styles from "./inputField.module.css";
import { ReactComponent as Down } from "../../Assets/icons/down.svg";
import { useCallback, useEffect, useRef } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import TextEditor from "../textEditor/textEditor";
import { debounce } from "lodash";

const InputField = (props) => {
  const selectRef = useRef();

  return (
    <>
      <div
        className={styles.field_contianer + " h-fit"}
        style={props.style ? { ...props.style } : {}}
      >
        {props.isLabel && (
          <p>
            {props.lable} {props.isRequired && "*"}{" "}
            {props?.showCharLength && (
              <span
                style={{
                  display: "inline-block",
                  float: "right",
                  fontSize: ".7rem",
                  marginRight: "10px",
                }}
              >
                {props.value?.length}/{props?.limitChar}
              </span>
            )}
          </p>
        )}
        {props.type === "select" ? (
          <div
            className={`${styles.select_container} ${
              props.error ? styles.error : ""
            }`}
          >
            <select
              ref={selectRef}
              value={props.value}
              onChange={props.onChange}
              name={props?.name ? props.name : ""}
            >
              <option value="" disabled selected>
                {props?.placeholder ? props?.placeholder : "Select your option"}
              </option>
              {props.options.map((val, index) => {
                return (
                  <option
                    key={index}
                    value={val[props?.accessValue]}
                    disabled={val?.disabled ? val.disabled : false}
                  >
                    {val[props?.accessText]}
                  </option>
                );
              })}
            </select>
            <Down
              onClick={() => {
                if (selectRef.current) {
                  selectRef.current?.click();
                }
              }}
            />
          </div>
        ) : props.type === "textarea" ? (
          <textarea
            className={styles.textarea}
            value={props.value}
            onChange={props.onChange}
            placeholder={props.placeholder}
            onKeyDown={props?.onKeyPress}
          ></textarea>
        ) : props.type === "date" ? (
          <div className={styles.input_container}>
            <input
              className={`${props?.error ? styles.error : ""} ${
                props?.fieldStyle ? props.fieldStyle : ""
              }`}
              type={props.type}
              placeholder={props.placeholder}
              name={props?.name ? props.name : ""}
              value={props.value}
              onChange={props.onChange}
              onKeyDown={props?.onKeyPress}
            ></input>
          </div>
        ) : props.type === "address" ? (
          <div className={styles.input_container_add}>
            <input
              className={`${props?.error ? styles.error : ""} ${
                props?.fieldStyle ? props.fieldStyle : ""
              }`}
              type={"text"}
              placeholder={"Address Line One"}
              name={"addLineOne"}
              value={props.value}
              onChange={props.onChange}
              onKeyDown={props?.onKeyPress}
              disabled={props.disabled || false}
            ></input>
            <input
              className={`${props?.error ? styles.error : ""} ${
                props?.fieldStyle ? props.fieldStyle : ""
              }`}
              type={"text"}
              placeholder={"Address 2"}
              name={"addLineTwo"}
              // value={props.value}
              onChange={props.onChange}
              onKeyDown={props?.onKeyPress}
            ></input>
            <span>
              <input
                className={`${props?.error ? styles.error : ""} ${
                  props?.fieldStyle ? props.fieldStyle : ""
                }`}
                type={"text"}
                placeholder={"City"}
                name={"city"}
                // value={props.value}
                onChange={props.onChange}
                onKeyDown={props?.onKeyPress}
              ></input>
              <input
                className={`${props?.error ? styles.error : ""} ${
                  props?.fieldStyle ? props.fieldStyle : ""
                }`}
                type={"text"}
                placeholder={"State"}
                name={"state"}
                // value={props.value}
                onChange={props.onChange}
                onKeyDown={props?.onKeyPress}
              ></input>
              <input
                className={`${props?.error ? styles.error : ""} ${
                  props?.fieldStyle ? props.fieldStyle : ""
                }`}
                type={"text"}
                placeholder={"Country"}
                name={"country"}
                // value={props.value}
                onChange={props.onChange}
                onKeyDown={props?.onKeyPress}
              ></input>
              <input
                className={`${props?.error ? styles.error : ""} ${
                  props?.fieldStyle ? props.fieldStyle : ""
                }`}
                type={"text"}
                placeholder={"Pin Code"}
                name={`pincode`}
                // value={props.value}
                onChange={props.onChange}
                onKeyDown={props?.onKeyPress}
              ></input>
            </span>
          </div>
        ) : props.type === "richtextEditor" ? (
          <TextEditor
            content={props.value}
            handleChange={props.onChange}
            placeholder={props?.placeholder}
            smallEditor={props?.smallEditor}
          />
        ) : (
          <div className={styles.input_container}>
            <input
              className={`${props?.error ? styles.error : ""} ${
                props?.fieldStyle ? props.fieldStyle : ""
              }`}
              type={props.type}
              placeholder={props.placeholder}
              name={props?.name ? props.name : ""}
              value={props.value}
              onChange={(e) => {
                if (
                  e.target.value.length <= props.limitChar &&
                  props?.limitChar
                ) {
                  props.onChange(e);
                } else if (!props?.limitChar) {
                  props.onChange(e);
                }
              }}
              onKeyDown={props?.onKeyPress}
            ></input>
            {props?.sideIcon && <div className={styles.side_icon}>%</div>}
          </div>
        )}
        {/* error text */}
        {props?.error && (
          <div className={styles.error_text}>
            <FontAwesomeIcon icon={faCircleExclamation} color="#C4270D" />
            <p>Error text goes here.</p>
          </div>
        )}
      </div>
    </>
  );
};

export default InputField;
